export const HAKLAI_PRISA_CREDIT_POINT_GENDER = Object.freeze({
  MALE: "male",
  FEMALE: "female"
});

export const HAKLAI_PRISA_CREDIT_POINT_RESIDENCY = Object.freeze({
  ISRAELI: "israeli",
  FOREIGN: "foreign"
});

export const calculateHaklaiPrisaCreditPoints = ({
  gender,
  residency
} = {}) => {
  if (!gender || !residency) return null;

  const residentPoints = residency === HAKLAI_PRISA_CREDIT_POINT_RESIDENCY.ISRAELI ? 2.25 : 0;
  const womanPoints = gender === HAKLAI_PRISA_CREDIT_POINT_GENDER.FEMALE ? 0.5 : 0;

  return residentPoints + womanPoints;
};

export const calculateHaklaiPrisaCreditPointsForPerson = (person = {}) => (
  calculateHaklaiPrisaCreditPoints({
    gender: person.creditPointGender,
    residency: person.creditPointResidency
  })
);

// Writes the calculated points into each prisa year. The sale year keeps its
// stored value while maximal mode is on, because that row displays zero.
// Pass yearIndexes to fill only those years, such as years just added.
export const applyHaklaiPrisaCreditPointsToPerson = (person, yearIndexes = null) => {
  const creditPoints = calculateHaklaiPrisaCreditPointsForPerson(person);
  if (creditPoints === null || !person) return person;
  const limitToIndexes = Array.isArray(yearIndexes);
  return {
    ...person,
    dataPerYear: (Array.isArray(person.dataPerYear) ? person.dataPerYear : []).map((year, yearIndex) => {
      if (limitToIndexes && !yearIndexes.includes(yearIndex)) return { ...year };
      if (yearIndex === 0 && person.isMaximal) return { ...year };
      return { ...year, zikui: creditPoints };
    })
  };
};

export const getHaklaiPrisaPersonCreditPointsValue = (person = {}) => {
  const dataPerYear = Array.isArray(person.dataPerYear) ? person.dataPerYear : [];
  return dataPerYear.length > 0 ? dataPerYear[0].zikui : "";
};
